<template>
  <app-main-layout>
    <!--  -->
    <!--  -->
    <template v-slot:left>
      <app-left-nav />
    </template>
    <!--  -->
    <template v-slot:bottom-nav>
      <app-bottom-nav />
    </template>
    <!--  -->
    <!--  -->
    <template v-slot:top>
      <app-top-nav padded>
        <template v-slot:left>
          <el-button
            v-if="false"
            type="text"
            plain
            circle
            is-all-borderless
            icon="el-icon-back"
          />
        </template>
        <template v-slot:center>
          <span nav-title>Opportunities</span>
        </template>
        <template v-slot:right> </template>
        <template v-slot:bottom>
          <el-menu
            :default-active="activeIndex"
            size-2
            router
            mode="horizontal"
          >
            <el-menu-item index="/opportunities/active?isArchived=false">
              <el-icon>
                <checked />
              </el-icon>
              <span>Active</span>
            </el-menu-item>
            <el-menu-item index="/opportunities/active?isArchived=true">
              <el-icon>
                <star />
              </el-icon>
              <span>Archived</span>
            </el-menu-item>
          </el-menu>
        </template>
      </app-top-nav>
    </template>
    <!--  -->
    <template v-slot:middle>
      <!--  -->
      <!-- Loaded Opportunities -->
      <div>
        <!--  -->
        <app-loader-opportunities
          :loading="loading"
          :resources="opportunities"
          content="Can't find any active opportunities."
        />
        <!--  -->
      </div>
    </template>
    <!--  -->
    <template v-slot:right>
      <app-right-nav>
        <app-user-right-intro />
      </app-right-nav>
    </template>
    <!--  -->
    <!--  -->
  </app-main-layout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Checked, Star } from "@element-plus/icons";
import { RouterUtilClass, VuexResourceFetchOptions } from "@/shared";
import { Watch } from "vue-property-decorator";

@Options({ components: { Checked, Star } })
export default class extends Vue {
  /**
   * @returns created opportunities
   */
  get opportunities() {
    return [];
  }
  /**
   * @returns the loading state of the created opportunities
   */
  get loading() {
    return this.$store.state.opportunities.loading;
  }

  /**
   * Active index for the nav
   */
  get activeIndex() {
    return (
      this.$route.path +
      (this.$route.query.isArchived !== undefined
        ? `?isArchived=${this.$route.query.isArchived}`
        : "")
    );
  }
  mounted() {
    if (this.$route.query.isArchived === undefined) {
      this.$router.push("/opportunities/active?isArchived=false");
    }
    this.fetch();
  }

  fetch() {
    this.$store.dispatch("opportunities/fetch", {
      q: RouterUtilClass.getQuery(this.$route),
      clear: true,
    } as VuexResourceFetchOptions);
  }

  @Watch("$route.query.isArchived")
  routeChanged() {
    this.fetch();
  }
}
</script>

<style lang="scss"></style>
